<template>
  <img
    v-lazy-image="src"
    :src="placeholder"
    :alt="alt"
    class="bpos-lazy-image"
    @error="handleError"
  >
</template>

<script>
const TRANSPARENT_PIXEL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

export default {
  name: 'LazyImage',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    // Возможность переопределить заглушку снаружи, если нужно
    customPlaceholder: {
      type: String,
      default: null
    }
  },
  computed: {
    placeholder() {
      return this.customPlaceholder || TRANSPARENT_PIXEL;
    }
  },
  methods: {
    handleError() {
      // Если реальная картинка не загрузилась (404), можно показать дефолтную иконку товара
      // e.target.src = require('@/assets/images/no-image.png');
      console.warn(`Failed to load image: ${this.src}`);
    }
  }
}
</script>

<style scoped>
/* Добавляем светло-серый фон, чтобы пользователь видел "коробку", пока картинка грузится */
.bpos-lazy-image {
  background-color: #f3f4f6;
  transition: opacity 0.3s ease-in-out;
  object-fit: cover;
}
</style>
